import { NonNullableStringParameter, useAssignQueryParameter } from '@pba/react-router';
import { useMemo } from 'react';

type P = {
  tokenKey?: string;
};

export const useUnsubscribeParams = ({ tokenKey = 'token' }: P = {}) => {
  const { value: token } = useAssignQueryParameter(tokenKey, NonNullableStringParameter);

  const params = useMemo(() => ({ token }), [token]);

  return useMemo(() => ({ params }), [params]);
};
